module.exports = __webpack_public_path__ + "static/media/website-designsteins-2.f2e1ed12.png";